import { inject, Injectable } from '@angular/core';
import { version } from '../../injectables';
import { Observable } from 'rxjs';
import { CampaignsVersionApiClient } from 'src/app/api/api-campaigns.service.generated';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  private accountManagementService = inject(CampaignsVersionApiClient);

  version: string;
  apiVersion$: Observable<string>;

  constructor() {
    const injectedVersion = inject(version, { optional: true });

    this.version = injectedVersion ? injectedVersion : '';
  }

  init() {
    this.apiVersion$ = this.accountManagementService.getVersionInfo();
  }
}
